/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import FileSystemType from '../../file/system/file-system-type';

/**
 * Resolver pro interní cestu.
 * @implements {InternalBasePath}
 */
class WebInternalBasePath {
  /**
   * Vytvoří instanci.
   * @param {FileSystemPathFactory} fileSystemPathFactory Továrna na cesty v souborovém systému.
   * @param {LogicalUnitMapper} logicalUnitMapper Mapovač logických jednotek
   * @returns {WebInternalBasePath} Nová instance.
   */
  constructor(fileSystemPathFactory, logicalUnitMapper) {
    this.fileSystemPathFactory = fileSystemPathFactory;
    this.logicalUnitMapper = logicalUnitMapper;
  }

  /**
   * Vrátí basepath pro platformově specifickou interní jednotku.
   * @param {LogicalUnit} logicalUnit logická jednotka.
   * @returns {Promise.<FileSystemPath>} Ukládací cesta.
   */
  resolve(logicalUnit) {
    return new Promise((resolve) =>
      resolve(
        this.logicalUnitMapper
          .toFileSystemUnit(logicalUnit)
          .then((fileSystemUnit) => {
            if (fileSystemUnit.getType() !== FileSystemType.Internal) {
              throw new Error('unit is not internal');
            }

            return this.fileSystemPathFactory.fromValue('/internal');
          })
      )
    );
  }
}

export default WebInternalBasePath;
